<div appModal (closeModal)="close()">
  <section class="modal-title-container">
    <div class="modal--title">Invite {{ invite.status }}</div>
  </section>

  <section class="modal-content-container">
    <div class="flex">
      <div class="img-container mr-10">
        <img [src]="invite.icon" alt="invite-icon" />
      </div>
      <div class="flex flex-col items-start justify-center">
        <p>{{ invite.email }}</p>
        <p>Invite sent {{ invite.invite.inviteEmailSentAt | fromDate }}</p>
      </div>
    </div>
  </section>

  <section class="modal-actions-container">
    <button class="btn btn-lg btn-red" [class.btn-disabled]="processing" (click)="cancelClick()">Cancel invite</button>
    <button class="btn btn-lg" [class.btn-disabled]="processing" (click)="send()">Resend invite</button>
  </section>
</div>
